import { Component, input, InputSignal, signal } from '@angular/core';
import { QuillModule } from 'ngx-quill';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControlExtended } from '@al00x/forms';
import { Observable } from 'rxjs';
import { CacButtonComponent, ButtonClickEvent } from '@controladad/ng-base';
import { NgIf } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface HtmlLanguageDataType {
  controller: FormControlExtended<string>;
  title?: string;
}

export interface PageEditorData {
  english: HtmlLanguageDataType;
  arabic: HtmlLanguageDataType;
}

@Component({
  selector: 'lib-page-editor',
  standalone: true,
  imports: [QuillModule, ReactiveFormsModule, CacButtonComponent, NgIf, MatProgressBarModule],
  templateUrl: './page-editor.component.html',
  styleUrl: './page-editor.component.scss',
})
export class PageEditorComponent {
  editorData: InputSignal<PageEditorData> = input.required<PageEditorData>();
  updateFunction: InputSignal<(() => Observable<string>) | null> = input<(() => Observable<string>) | null>(null);
  isLoadingData: InputSignal<boolean> = input<boolean>(false);

  isLoading = signal(false);
  activateRTL(editor: any) {
    editor.format('align', 'right');
    editor.format('direction', 'rtl');
  }
  update(e: ButtonClickEvent) {
    const res = this.updateFunction();
    if (!res) return;
    
    res().pipe(e.pipe()).subscribe({
      next: () => {
        snackbar$.show(`${this.editorData().english.title} updated successfully`);
      },
      error: (err) => {
        snackbar$.error(`Error updating ${this.editorData().english.title}: ${err}`);
      },
    });
  }
}
